import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useNavigationType, useParams } from 'react-router-dom';
import { reverse } from 'named-urls';
import { clearResponseData, getAuction } from '../MyVehiclesActions';
import AuctionDetailsItem from '../../common/components/Auction/AuctionDetailsItem';
import { auctionListType } from '../../constants/AuctionListType';
import { SSE_SELLER, SSEClient } from '../../api/SSEClient';
import RouterPaths from '../../constants/RouterPaths';
import AddVehicleConfirmPage from '../../addvehicle/AddVehicleConfirmPage';
import { AuctionListTemplateContextType } from '../../common/components/new/AuctionListTemplate';

const MyVehiclesDetailsPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const location = useLocation();

  const responseAuctionDetails = useSelector((state) =>
    state.addVehicle.get('auctionDetails'),
  );
  const [item, setItem] = useState(null);
  const sseClient = new SSEClient(SSE_SELLER);
  const sellerId = useSelector((state) => state.auth.get('id'));
  const [step, setStep] = useState(1);
  const [isRepublish, setIsRepublish] = useState(false);
  const [auctionTimestamp, setAuctionTimestamp] = useState(null);

  useEffect(() => {
    if (navigationType === 'POP') {
      const updatedState = {
        ...(location.state || {}),
        auctionId: id,
      };

      sessionStorage.setItem('auctionState', JSON.stringify(updatedState));
    }
  }, [navigationType, location.state, id]);

  useEffect(() => {
    setItem(null);
    if (!responseAuctionDetails) {
      handleGetAuction();
    }
    return () => {
      dispatch(clearResponseData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  const handleGetAuction = (auction) => {
    setAuctionTimestamp(new Date());

    if (auction) {
      setItem(auction);
    } else {
      dispatch(
        getAuction(id, (auction) => {
          if (sellerId === auction.seller.id) {
            setItem(auction);
          } else {
            navigate(reverse(RouterPaths.SEARCH_DETAILS, { id }), {
              state: {
                ...(location.state || {}),
                auctionId: id,
              },
            });
          }
        }),
      );
    }
  };

  const prevStep = () => {
    setStep((prevState) => prevState - 1);
  };

  const nextStep = () => {
    setStep((prevState) => prevState + 1);
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          (item || responseAuctionDetails) && (
            <AuctionDetailsItem
              item={item || responseAuctionDetails}
              listType={auctionListType.MY_VEHICLES}
              refreshItem={handleGetAuction}
              sseClient={sseClient}
              typeSseClient={SSE_SELLER}
              nextStep={nextStep}
              setIsRepublish={setIsRepublish}
              auctionTimestamp={auctionTimestamp}
              inWrapper
              context={AuctionListTemplateContextType.SELLING}
            />
          )
        );
      case 2:
        return (
          <AddVehicleConfirmPage
            item={item}
            prevStep={prevStep}
            nextStep={nextStep}
            isRepublish={isRepublish}
            refreshItem={handleGetAuction}
          />
        );
      default:
        return null;
    }
  };

  return renderStep();
};

export default MyVehiclesDetailsPage;
